import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Classes
import { Client } from 'src/app/@shared/models/client/client.model';

// Utils
import { Logger } from '../logger/logger.service';
import { QueryOptionsParam } from 'src/app/@shared/utilities/odata/query-params';

const LOGGER = new Logger('ClientService');

const CLASS_NAME = 'Client';
const ENDPOINT = `/clients/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'authorizations', path: 'authorizations/', childClass: null },
    { key: 'avatar', path: 'avatar/', childClass: 'File', resultCardinality: 'one' },
    { key: 'contacts', path: 'contacts/', childClass: 'ClientContact' },
    { key: 'logo', path: 'logo/', childClass: 'File', resultCardinality: 'one' },
    { key: 'subscription', path: 'subscription/', childClass: 'Subscription', resultCardinality: 'one' },
]
const ROUTES: RouteParam[] = [
    {key: 'activate', path: '{id}/activate/'},
    {key: 'firmClients', path: '{id}/clients/'},
    {key: 'mine', path: 'mine/'},
    {key: 'reset', path: '{id}/reset/'},
]

@Injectable({
    providedIn: 'root'
})
export class ClientService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public activate$(client: Client): Observable<any> {
        return this.update$(client, {
            url: this.routes.activate.replace('{id}', client.id.toString()),
            select: false
        });
    }

    public delete$(client: Client, phrase: string | null): Observable<any> {
        client.deleted = true;
        client.deletePhrase = phrase;
        return this.save$(client, {
            url: this.routes.reset.replace('{id}', client.id.toString()),
        });
    }

    /**
     * Appel du webservice des clients auxquelles appartient l'utilisateur
     */
    public getMine$(): Observable<Client[]> {
        LOGGER.debug('Chargement de la liste des clients');
        let options: QueryOptionsParam = { url: this.routes.mine };
        return this.getList$(options).pipe(
            map((clients: Client[]) => {
                LOGGER.debug(`${clients.length} clients chargés`);
                return clients;
            })
        );
    }

    /**
     * Appel du webservice des clients d'un cabinet comptable
     */
    public getAccountingFirmClients$(clientId: number): Observable<Client[]> {
        LOGGER.debug('Chargement des clients du cabinet', clientId);
        let url = this.routes['firmClients'].replace('{id}', clientId.toString());
        return this.getList$({ url, expands: ['subscription'] });
    }

    public reset$(client: Client, phrase: string | null): Observable<any> {
        client.resetPhrase = phrase;
        return this.update$(client, {
            url: this.routes.reset.replace('{id}', client.id.toString()),
        });
    }

    public uploadLogo$(client: Client, file: File): Observable<any> {
        let url = this.routes['single'].replace('{id}', client.id.toString()) + this.navigations['logo'].path;
        return this.uploadFile$(file, url);
    }

    public uploadAvatar$(client: Client, file: File): Observable<any> {
        let url = this.routes['single'].replace('{id}', client.id.toString()) + this.navigations['avatar'].path;
        return this.uploadFile$(file, url);
    }
}
